(() => {
  const storeHosts = new Set(['nanasmarket.com', 'www.nanasmarket.com', 'm36qvm-rh.myshopify.com', window.location.hostname]);
  const url = (href) => {
    const current = new URL(window.location.href);
    const previewTheme = current.searchParams.get('preview_theme_id');
    if (!previewTheme || !/^\d+$/.test(previewTheme)) return href;
    let destination;
    try { destination = new URL(href, current); } catch { return href; }
    if (!['https:', 'http:'].includes(destination.protocol) || !storeHosts.has(destination.hostname)) return href;
    destination.protocol = current.protocol;
    destination.host = current.host;
    destination.searchParams.set('preview_theme_id', previewTheme);
    return destination.href;
  };
  window.NanaPreviewNavigation = { url };
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download') || link.getAttribute('href').startsWith('#')) return;
    const next = url(link.href);
    if (next !== link.href) link.href = next;
  }, true);
})();

document.addEventListener('click', (event) => {
  for (const menu of document.querySelectorAll('.nana-recipes-menu[open], .nana-mobile-menu[open], .nana-signpost[open]')) {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  }
});
const nanaSignpost = document.querySelector('.nana-signpost');
if (nanaSignpost) nanaSignpost.open = false;
const nanaVillageLinks = document.querySelector('.nana-village-links-disclosure');
const nanaMobile = window.matchMedia('(max-width: 1000px)');
if (nanaVillageLinks) {
  nanaVillageLinks.open = !nanaMobile.matches;
  nanaMobile.addEventListener('change', event => { nanaVillageLinks.open = !event.matches; });
}
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const origin = event.target.closest('details[open]');
  let returnFocus = origin?.querySelector('summary');
  for (const menu of document.querySelectorAll('.nana-recipes-menu[open], .nana-mobile-menu[open], .nana-signpost[open], .nana-village-links-disclosure[open]')) {
    if (menu === nanaVillageLinks && !nanaMobile.matches) continue;
    menu.removeAttribute('open');
    returnFocus ||= menu.querySelector('summary');
  }
  returnFocus?.focus();
});


